import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import 'lib-flexible'
import i18n from "./lang/index"

Vue.config.productionTip = false

const currentDomain = window.location.hostname
if (currentDomain === 'bbee-mobile.91act.com') {
  window.location.href = "https://bbeex-mobile.91act.com"
} else {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app")
}
